import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c9d9a0e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circuit-routing-introduction-dialog__title"
}, "答题说明", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circuit-routing-introduction-dialog__content"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/img/circuit-routing-introduction.jpg",
  alt: "电路布线配对的规则说明"
})], -1));
const _hoisted_3 = {
  class: "circuit-routing-introduction-dialog__footer"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/favicon.png",
  alt: "logo",
  class: "title-logo"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml16 ft18 boldFont"
}, "速记星超常儿童智力甄别和训练系统", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WatermarkerView = _resolveComponent("WatermarkerView");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_row = _resolveComponent("el-row");
  const _component_DigitSymbolReactionSession = _resolveComponent("DigitSymbolReactionSession");
  const _component_AnswerCard = _resolveComponent("AnswerCard");
  const _component_el_col = _resolveComponent("el-col");
  const _component_QuestionRenderPage = _resolveComponent("QuestionRenderPage");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_WatermarkerView), _createVNode(_component_el_dialog, {
    modelValue: $data.circuitRoutingIntroductionVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.circuitRoutingIntroductionVisible = $event),
    class: "circuit-routing-introduction-dialog",
    width: "min(96vw, 1360px)",
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false,
    "destroy-on-close": false,
    "align-center": ""
  }, {
    header: _withCtx(() => [_hoisted_1]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      type: "primary",
      loading: $data.circuitRoutingIntroductionSubmitting,
      onClick: $options.acknowledgeCircuitRoutingIntroduction
    }, {
      default: _withCtx(() => [_createTextVNode(" 我知道了 ")]),
      _: 1
    }, 8, ["loading", "onClick"])])]),
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", {
    class: _normalizeClass(["TrainAnswerViewContainer", {
      'reaction-page': $data.subject === 'DigitSymbolReaction'
    }])
  }, [_createVNode(_component_el_row, {
    class: "wd100 wbg flex items-center opd20 ptr",
    style: {
      "height": "60px"
    },
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/'))
  }, {
    default: _withCtx(() => [_hoisted_4, _hoisted_5]),
    _: 1
  }), $data.session && $data.subject === 'DigitSymbolReaction' ? (_openBlock(), _createBlock(_component_DigitSymbolReactionSession, {
    key: 0,
    session: $data.session,
    mode: "practice"
  }, null, 8, ["session"])) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "mt32",
    style: {
      "width": "1278px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      style: {
        "display": "flex"
      }
    }, {
      default: _withCtx(() => [$data.session && $data.answerStarted ? (_openBlock(), _createBlock(_component_AnswerCard, {
        key: 0,
        width: $options.ansModeMap() < 1 ? 4 : 0,
        onTimeup: $options.onTimeUp,
        current: $data.current,
        "group-size": $options.ansTypeMap(),
        session: $data.session
      }, null, 8, ["width", "onTimeup", "current", "group-size", "session"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "pdl10"
    }, {
      default: _withCtx(() => [$data.session && $data.answerStarted ? (_openBlock(), _createBlock(_component_QuestionRenderPage, {
        key: 0,
        ref: "questionRender",
        onNext: _cache[2] || (_cache[2] = $event => $data.current += $options.ansTypeMap()),
        "group-size": $options.ansTypeMap(),
        subject: $data.subject,
        data: $data.session
      }, null, 8, ["group-size", "subject", "data"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }))], 2)], 64);
}